/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AcquisitionBucketCountFromJSON, AcquisitionBucketCountToJSON } from './AcquisitionBucketCount';
import { UtmSourceCountFromJSON, UtmSourceCountToJSON } from './UtmSourceCount';
/**
 * Check if a given object implements the VisitsStats interface.
 */
export function instanceOfVisitsStats(value) {
    if (!('byLandingPath' in value) || value['byLandingPath'] === undefined)
        return false;
    if (!('byUtmCampaign' in value) || value['byUtmCampaign'] === undefined)
        return false;
    if (!('byUtmContent' in value) || value['byUtmContent'] === undefined)
        return false;
    if (!('byUtmSource' in value) || value['byUtmSource'] === undefined)
        return false;
    if (!('total' in value) || value['total'] === undefined)
        return false;
    if (!('welcomeRate' in value) || value['welcomeRate'] === undefined)
        return false;
    if (!('withWelcome' in value) || value['withWelcome'] === undefined)
        return false;
    return true;
}
export function VisitsStatsFromJSON(json) {
    return VisitsStatsFromJSONTyped(json, false);
}
export function VisitsStatsFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'byLandingPath': (json['by_landing_path'].map(AcquisitionBucketCountFromJSON)),
        'byUtmCampaign': (json['by_utm_campaign'].map(AcquisitionBucketCountFromJSON)),
        'byUtmContent': (json['by_utm_content'].map(AcquisitionBucketCountFromJSON)),
        'byUtmSource': (json['by_utm_source'].map(UtmSourceCountFromJSON)),
        'total': json['total'],
        'welcomeRate': json['welcome_rate'],
        'withWelcome': json['with_welcome'],
    };
}
export function VisitsStatsToJSON(json) {
    return VisitsStatsToJSONTyped(json, false);
}
export function VisitsStatsToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'by_landing_path': (value['byLandingPath'].map(AcquisitionBucketCountToJSON)),
        'by_utm_campaign': (value['byUtmCampaign'].map(AcquisitionBucketCountToJSON)),
        'by_utm_content': (value['byUtmContent'].map(AcquisitionBucketCountToJSON)),
        'by_utm_source': (value['byUtmSource'].map(UtmSourceCountToJSON)),
        'total': value['total'],
        'welcome_rate': value['welcomeRate'],
        'with_welcome': value['withWelcome'],
    };
}
